import {
  MultiSelect,
  type MultiSelectProps,
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "@design-system/shadcn";
import React from "react";

import { useFilters } from "../filters-provider";

interface FilterBarMultiSelectProps extends Omit<
  MultiSelectProps,
  "value" | "onValueChange" | "variant"
> {
  name: string;
  tooltip?: string;
}

function FilterBarMultiSelect({
  name,
  tooltip,
  ...props
}: FilterBarMultiSelectProps) {
  const { getValue, setValue, visibleFilters } = useFilters();

  if (!visibleFilters.includes(name)) {
    return null;
  }

  const value = getValue(name);

  const field = (
    <MultiSelect
      {...props}
      variant="pill"
      value={Array.isArray(value) ? value : []}
      onValueChange={(next) => setValue(name, next)}
    />
  );

  if (!tooltip) {
    return field;
  }

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <span className="inline-flex">{field}</span>
      </TooltipTrigger>
      <TooltipContent>{tooltip}</TooltipContent>
    </Tooltip>
  );
}

export { FilterBarMultiSelect };
export type { FilterBarMultiSelectProps };
